// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"b83c4ca7","346":"4069e9f5","965":"63f342f6"}[chunkId] + ".chunk.css";
};